import {
  HCAPTCHA_SITE_KEY_DEV,
  HCAPTCHA_SITE_KEY_PROD,
  PROD_ENVIRONMENTS_FOR_CAPTCHA,
} from 'constants/captcha';

let environment = '';
const encodedEnvironment = window.xprops?.env;

if (encodedEnvironment) {
  environment = atob(encodedEnvironment);
}

export const captchaKey = PROD_ENVIRONMENTS_FOR_CAPTCHA.includes(environment)
  ? HCAPTCHA_SITE_KEY_PROD
  : HCAPTCHA_SITE_KEY_DEV;
